export const selectIsAnyPopupShown = (state) => !!state.popup.popup;
